import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import SupervisorTable from "./SupervisorTable";

const AddSupervisorModal = ({
    openModal = false,
    setOpenModal,
    selectedEmployees,
    supervisorId,
    isAllSelectedEmployees = false,
    employeeAdditionalWhere = '',
    employeeTableName,
    setResponsed
}) => {

    const handleClose = () => {
        setOpenModal(false);
    };

    return (
        <>
            <Dialog
                open={openModal}
                onClose={handleClose}
                scroll="body"
                PaperProps={{
                    sx: {
                        maxWidth: 1500,
                    },
                }}
                fullWidth={true}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            margin: "0",
                        }}
                    >
                        <h5 className="mt-2">Assign to Supervisor</h5>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </DialogTitle>

                <DialogContent>
                    {supervisorId && (
                        <SupervisorTable
                            isAllSelectedEmployees={isAllSelectedEmployees}
                            selectedEmployees={selectedEmployees}
                            supervisorId={supervisorId}
                            handleClose={handleClose}
                            employeeAdditionalWhere={employeeAdditionalWhere}
                            employeeTableName={employeeTableName}
                            setResponsed={setResponsed}
                        />
                    )}
                </DialogContent>

            </Dialog>
        </>
    );
};

export default AddSupervisorModal;
